import { Observable } from 'rxjs';

export interface StandaloneActionButton {
  text: string;
  click: () => void;
  disabled$?: Observable<boolean>;
}
